import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/contact/contact_delete.svg';
const ContactDeleteSvg = () => React.createElement(IconSvg, null);
export default ContactDeleteSvg;
